module.exports = "#version 300 es\r\nprecision highp float;\r\n\r\nin vec4 fs_Col;\r\nin vec4 fs_Pos;\r\n\r\n//ins for lambert\r\nin vec4 fs_Nor; \r\nin vec4 fs_LightDir; \r\n\r\nout vec4 out_Col;\r\n\r\nvoid main()\r\n{\r\n\r\n    float diffuseTerm = dot(normalize(fs_Nor), normalize(fs_LightDir)); \r\n    float ambientTerm = 0.25; \r\n    float lightIntensity = diffuseTerm + ambientTerm; \r\n\r\n    out_Col = vec4(fs_Col.rgb * lightIntensity, fs_Col.a); \r\n\r\n    //out_Col = fs_Col;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/instanced-lambert-frag.glsl
// module id = 78
// module chunks = 0